export default function SourceCandidateManuallyIco() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.82312 4.24278C6.16802 3.60031 7.08935 3.60031 7.43425 4.24278L8.81383 6.81262C8.89883 6.97096 9.0286 7.10073 9.18694 7.18573L11.7568 8.56531C12.3993 8.91021 12.3993 9.83154 11.7568 10.1764L9.18694 11.556C9.0286 11.641 8.89883 11.7708 8.81383 11.9291L7.43425 14.499C7.08935 15.1414 6.16802 15.1414 5.82312 14.499L4.44355 11.9291C4.35855 11.7708 4.22877 11.641 4.07044 11.556L1.50059 10.1764C0.858122 9.83154 0.858122 8.91021 1.50059 8.56531L4.07044 7.18573C4.22877 7.10073 4.35855 6.97096 4.44355 6.81262L5.82312 4.24278Z"
        fill="#7F56D9"
      />
      <path
        d="M12.1545 0.776166C12.3329 0.443856 12.8095 0.443856 12.9879 0.776166L13.7015 2.1054C13.7454 2.1873 13.8125 2.25442 13.8944 2.29839L15.2237 3.01196C15.556 3.19036 15.556 3.66691 15.2237 3.8453L13.8944 4.55888C13.8125 4.60284 13.7454 4.66997 13.7015 4.75186L12.9879 6.0811C12.8095 6.41341 12.3329 6.41341 12.1545 6.0811L11.441 4.75186C11.397 4.66997 11.3299 4.60284 11.248 4.55888L9.91874 3.8453C9.58643 3.66691 9.58643 3.19036 9.91874 3.01196L11.248 2.29839C11.3299 2.25442 11.397 2.1873 11.441 2.1054L12.1545 0.776166Z"
        fill="#7F56D9"
      />
    </svg>
  );
}
